// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3bSnB","vLegacy":"SelectSecondary_vLegacy__2LnEL","error":"SelectSecondary_error__1MNhy","disabled":"SelectSecondary_disabled__GoA6R"};